











import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type BaseMapperData = {
	BARVA_KOD: string;
	FAKTURACE_DAT: string;
	ID: unknown;
	KOMISE_NR: string;
	OSOBNI_CIS_ZKR: unknown;
	PNV_ID: number;
	PNV_NR: number;
	PREDANI_DAT: string;
	TYPKOD: string;
	VIN: string;
	VSTUP_DAT: string;
	X_TYPKOD: string;
	X_ZAKAZNIK: string;
};

type RequestedData = {
	barvaKod: string | null;
	fakturaceDat: string | null;
	value: string | null;
	komiseNr: string | null;
	osobniCisloZkr: unknown | null;
	pnvId: number | null;
	text: string | null;
	predaniDat: string | null;
	typkod: string | null;
	vin: string | null;
	vstupDat: string | null;
	tykodText: string | null;
	zakaznikText: string | null;
};

type Data = {
	valueFieldName: string;
	storeObject: string;
	emptyObject: RequestedData;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		filter: { type: Object, default: () => {} },
		text: { type: Number },
	},
	data() : Data {
		return {
			storeObject: NAME,
			valueFieldName: 'X_PNV_ID',
			emptyObject: {
				barvaKod: null,
				fakturaceDat: null,
				value: null,
				komiseNr: null,
				osobniCisloZkr: null,
				pnvId: null,
				text: null,
				predaniDat: null,
				typkod: null,
				vin: null,
				vstupDat: null,
				tykodText: null,
				zakaznikText: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: BaseMapperData) {
			return {
				barvaKod: data.BARVA_KOD,
				fakturaceDat: data.FAKTURACE_DAT,
				value: data.ID,
				komiseNr: data.KOMISE_NR,
				osobniCisloZkr: data.OSOBNI_CIS_ZKR,
				pnvId: data.PNV_ID,
				pnvNr: data.PNV_NR,
				text: `${data.PNV_NR}`,
				predaniDat: data.PREDANI_DAT,
				typkod: data.TYPKOD,
				vin: data.VIN,
				vstupDat: data.VSTUP_DAT,
				tykodText: data.X_TYPKOD,
				zakaznikText: data.X_ZAKAZNIK,
			};
		},
		async openView() {
			// TODO: TFS#8039
			await openEdit(NAME, PageMode.VIEW, { id: this.value as any });
		},
	},
});
